import { DayOfWeek } from 'globalTypes';
import { Option } from 'components/Select';

export type CoachingSessionFrequency =
  | 'once'
  | 'weeklyOngoing'
  | 'weeklyWithEnd'
  | 'everyOtherWeekOngoing'
  | 'everyOtherWeekWithEnd';
export type CoachingSessionDuration = 20 | 40 | 60;

export default {
  DEFAULT_SIGNED_IN_ROUTE: '/log_in',
  COACHING_GET_APP_ROUTE: '/get_the_app',
  COACHING_PURCHASE_INTRO_ROUTE: '/coaching/get_started',
  COACHING_PURCHASE_REVIEW_ROUTE: '/coaching/review',
  COACHING_AVAILABILITY_ROUTE: '/coaching/schedule',
  COACHING_HOME_ROUTE: '/coaching/home',
  COACHING_HOME_MOBILE_ROUTE: '/coaching/home/mobile',
  COACHING_COORDINATOR_ROUTE: '/coaching/coordinator',
  COACHING_SESSION_ROUTE: '/coaching/session',
  COACHING_CHAT_STREAM_ROUTE: '/coaching/messages/:streamUuid',
  MANAGE_COACH_AVAILABILITY: 'Manage your Remind Coaching availability',
  TESTIMONIALS: [
    {
      quoteText:
        'For the first session, I sat in the background and was very impressed. After the first session, I was able to get chores done around the house.',
      authorName: 'Nicole',
      authorDescription: '12th Grade Parent',
    },
    {
      quoteText:
        'I’d never before considered online tutoring for my kids, but this session changed my mind.',
      authorName: 'Laura',
      authorDescription: '8th Grade Parent',
    },
  ],
  // prettier-ignore
  VALID_COACHING_HOURS: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
  VALID_COACHING_DAYS: [
    DayOfWeek.Monday,
    DayOfWeek.Tuesday,
    DayOfWeek.Wednesday,
    DayOfWeek.Thursday,
  ],
  START_OF_COACHING_HOURS_IN_PACIFIC: 13, // 1PM absolute hour e.g. 0-23
  END_OF_COACHING_HOURS_IN_PACIFIC: 20, // 8PM absolute hour e.g. 0-23
  SORTED_DAYS_OF_WEEK: [
    DayOfWeek.Sunday,
    DayOfWeek.Monday,
    DayOfWeek.Tuesday,
    DayOfWeek.Wednesday,
    DayOfWeek.Thursday,
    DayOfWeek.Friday,
    DayOfWeek.Saturday,
  ],
  TIMEZONES_TO_EXCLUDE: ['AKST', 'AKDT', 'HST', 'HDT'],
  COACHING_FREQUENCIES: [
    {
      label: 'Once',
      value: 'once',
    },
    {
      label: 'Weekly - Ongoing',
      value: 'weeklyOngoing',
    },
    {
      label: 'Weekly - Ends on date',
      value: 'weeklyWithEnd',
    },
    {
      label: 'Every Other Week - Ongoing',
      value: 'everyOtherWeekOngoing',
    },
    {
      label: 'Every Other Week - Ends on date',
      value: 'everyOtherWeekWithEnd',
    },
  ] as Option[],
  COACHING_SESSIONS_PAGE_LENGTH: 4,
  COACHING_SESSION_RECORDINGS_LIMIT: 5,
  DELETE_COACHING_SESSION_MODAL_ONGOING: {
    headerText: 'Remove ongoing series',
    confirmText: 'Remove all upcoming',
    cancelText: 'Keep sessions',
  },
  DELETE_COACHING_SESSION_MODAL_SINGLE: {
    headerText: 'Remove session',
    confirmText: 'Remove session',
    cancelText: 'Keep session',
  },
};
